import { c as _c } from "react/compiler-runtime";
import type { ChangeEvent } from 'react';
import { SelectField } from '../../SelectField';
import type { AutoshipFrequencyItem } from '../lib';
type AutoshipFrequencySelectProps = Readonly<{
  items: AutoshipFrequencyItem[];
  value: string;
  onChange: (value: string) => void;
  testId?: string;
}>;
export const AutoshipFrequencySelect = t0 => {
  const $ = _c(7);
  const {
    items,
    value,
    onChange,
    testId: t1
  } = t0;
  const testId = t1 === undefined ? "select-frequency" : t1;
  let t2;
  if ($[0] !== onChange) {
    t2 = event => onChange(event.target.value);
    $[0] = onChange;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== items || $[3] !== t2 || $[4] !== testId || $[5] !== value) {
    t3 = <SelectField label="Ships every" items={items} onChange={t2} data-testid={testId} value={value} />;
    $[2] = items;
    $[3] = t2;
    $[4] = testId;
    $[5] = value;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};